import { useMemo, useRef, useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import notify from "../common/notify";

export const TabButton = ({
  children,
  url,
  disabled,
  onClick,
  setActive,
  activeTab,
}) => {
  const isActive = useMemo(() => activeTab === url, [activeTab, url]);
  return (
    <button
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          notify("This tab is disabled in preview mode!");
          return;
        }
        setActive(url);
        onClick?.(e);
      }}
      className={`text-sm mlg:text-base font-medium py-2.5 px-5 min-w-fit rounded-xl transition-all duration-300 ${
        isActive 
          ? "bg-gradient-to-r from-primary to-[#7e7cff] text-white shadow-md" 
          : "bg-gray-50 hover:bg-gray-100 text-gray-600 hover:text-gray-800"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      {children}
    </button>
  );
};

export const TabContainer = ({ children }) => {
  const tabsRef = useRef(null);
  const [tabsScrollLeft, setTabsScrollLeft] = useState(0);

  return (
    <section className="w-full relative">
      {tabsScrollLeft > 0 && (
        <button
          onClick={() => {
            let scrollLeft = tabsRef.current.scrollLeft;
            let scrollWidth = tabsRef?.current?.scrollWidth;
            let clientWidth = tabsRef.current.clientWidth;
            tabsRef.current.scrollTo({
              left:
                scrollLeft -
                Math.min(clientWidth - 50, scrollWidth - scrollLeft),
              behavior: "smooth",
            });
            setTabsScrollLeft(tabsRef.current.scrollLeft);
          }}
          className="absolute -left-1 top-0 bg-[#ffffff] h-full shadow-lg rounded-l-full"
        >
          <HiChevronLeft
            color="#505050"
            className=""
            fontWeight={100}
            size={26}
          />
        </button>
      )}
      {tabsScrollLeft <
        tabsRef?.current?.scrollWidth - tabsRef?.current?.clientWidth && (
        <button
          onClick={() => {
            let scrollLeft = tabsRef.current.scrollLeft;
            let scrollWidth = tabsRef?.current?.scrollWidth;
            let clientWidth = tabsRef.current.clientWidth;

            tabsRef.current.scrollTo({
              left:
                scrollLeft +
                Math.min(clientWidth - 50, scrollWidth - scrollLeft),
              behavior: "smooth",
            });
            setTabsScrollLeft(tabsRef.current.scrollLeft);
          }}
          className="absolute -right-1 top-0 bg-white h-full shadow-lg rounded-r-full"
        >
          <HiChevronRight
            color="#505050"
            className=""
            fontWeight={100}
            size={26}
          />
        </button>
      )}
      <div
        ref={tabsRef}
        onScroll={(e) => {
          setTabsScrollLeft(e.target.scrollLeft);
        }}
        className={`w-full md:w-fit flex items-center overflow-x-auto py-3 gap-x-2 rounded-2xl bg-gray-50/80 px-3 shadow-sm ${
          tabsScrollLeft <
            tabsRef?.current?.scrollWidth - tabsRef?.current?.clientWidth ||
          tabsScrollLeft > 0
            ? "pr-7"
            : ""
        } ${tabsScrollLeft > 0 && "pl-7"} `}
      >
        {children}
      </div>
    </section>
  );
};

export const Tab = ({ tabs, activeTab }) => {
  const { component } = tabs.find((tab) => tab.url === activeTab) ?? {};
  return component ?? null;
};
